( function( window, $ ) {
	'use strict';

	$( document ).ready( function() {

		// Check to see if an accordion enabled element needs a Read More button

		var readmore = function( el ) {

			if ( document.querySelector( el ) ) {

				var accordions = document.querySelectorAll( el );

				for ( var i = 0; i < accordions.length; i++ ) {

					var contentEl = accordions[i].querySelectorAll( '.content' )[0],
						additionalEl = accordions[i].querySelectorAll( '.additional' )[0],
						parentRowEl = accordions[i].parentNode.parentNode;

					// Check .content clientHeight against .additonal
					if ( additionalEl.clientHeight < contentEl.clientHeight ) {

						parentRowEl.classList.add( 'no-readmore' );

					}

				}

			}

		};

		// Set up for the Leadership page
		readmore( '.bio' );

		// Set up for the about section on the location pages.
		readmore( '.location-about' );

	} );

} )( window, jQuery );
